import { createSlice, current } from "@reduxjs/toolkit";
import {
  GetAllDropDownData,
  GetAllGenderList,
  GetAllIdentifierType,
  GetAllMaritalList,
  GetAllNationalityList,
  GetAllProcessPriority,
  GetAllProfession,
  GetAllPurposeList,
  GetAllRelationShip,
  GetInsuranceList,
  SearchPatientByID,
  SubmitEligibilityCheck,
} from "./eligibilityCheckApi";
import { toast } from "react-toastify";
import { GetSingleEligibilityData } from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";

const eligibilityCheckSlice = createSlice({
  name: "eligibilityCheck",
  initialState: {
    insuranceList: [],
    genderList: [],
    maritalList: [],
    professionList: [],
    relationshipList: [],
    processPriorityList: [],
    nationalityList: [],
    purposeList: [],
    identifierTypeList: [],
    relatedRelationShip: [],
    patientSearchData: null,
    eligibilityCheckData: null,
    religionList: [],
  },
  reducers: {
    handleResetPatientSearch: (state, _) => {
      state.patientSearchData = null;
      state.eligibilityCheckData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetInsuranceList.fulfilled, (state, action) => {
        state.insuranceList = action.payload?.data?.insurance_company_id;
      })
      .addCase(GetAllGenderList.fulfilled, (state, action) => {
        state.genderList = action.payload?.data?.patient_gender;
      })
      .addCase(GetAllMaritalList.fulfilled, (state, action) => {
        state.maritalList = action?.payload?.data?.patient_marital;
      })
      .addCase(GetAllProfession.fulfilled, (state, action) => {
        state.professionList = action.payload?.data?.patient_profession;
      })
      .addCase(GetAllRelationShip.fulfilled, (state, action) => {
        state.relationshipList = action.payload?.data?.patient_relation;
      })
      .addCase(GetAllProcessPriority.fulfilled, (state, action) => {
        state.processPriorityList = action.payload?.data?.benf_type;
      })
      .addCase(GetAllNationalityList.fulfilled, (state, action) => {
        state.nationalityList = action.payload?.data?.ntnlid_type;
      })
      .addCase(GetAllPurposeList.fulfilled, (state, action) => {
        state.purposeList = action.payload?.data?.eligib_purpose;
      })
      .addCase(SubmitEligibilityCheck.fulfilled, (state, action) => {
        state.eligibilityCheckData = action.payload?.data;
      })
      .addCase(SearchPatientByID.fulfilled, (state, action) => {
        state.patientSearchData = action.payload?.data?.patientsearch_data;
      })
      .addCase(GetAllIdentifierType.fulfilled, (state, action) => {
        state.identifierTypeList = action?.payload?.data?.idenf_type;
      })
      .addCase(GetSingleEligibilityData.fulfilled, (state, action) => {
        state.eligibilityCheckData = action.payload?.data;
      })
      .addCase(GetAllDropDownData.fulfilled, (state, action) => {
        state.identifierTypeList = action?.payload?.data?.idenf_type;
        state.purposeList = action.payload?.data?.eligib_purpose;
        state.nationalityList = action.payload?.data?.ntnlid_type;
        state.processPriorityList = action.payload?.data?.benf_type;
        state.relationshipList = action.payload?.data?.patient_relation;
        state.professionList = action.payload?.data?.patient_profession;
        state.maritalList = action?.payload?.data?.patient_marital;
        state.genderList = action.payload?.data?.patient_gender;
        state.religionList = action.payload?.data?.patient_religion;
        state.relatedRelationShip = action.payload?.data?.related_relationship;
      });
  },
  //
});

export const { handleResetPatientSearch } = eligibilityCheckSlice.actions;
export default eligibilityCheckSlice.reducer;
